import { VONS } from "../../VO/VONS.js";
export class SelectorPathView {
  constructor({ selector_path_el }) {
    this._selector_path_el = selector_path_el;
  }
  observeSelectorController({
    is_show,
    ne_point,
    se_point,
    sw_point,
    nw_point,
  }) {
    if (is_show) {
      this._selector_path_el.style.display = "";
    } else {
      this._selector_path_el.style.display = "none";
    }
    const d = `M ${nw_point.x} ${nw_point.y} L ${ne_point.x} ${ne_point.y} L ${se_point.x} ${se_point.y} ${sw_point.x} ${sw_point.y} Z`;
    this._selector_path_el.setAttributeNS(null, "d", d);
  }
}
